import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
// import { HttpModule } from '@angular/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';

// Together modules.
import { TogetherHeaderComponent } from './together.header';
import { TogetherFooterComponent } from './together.footer';
import { TogetherMainComponent } from './together.main';
import { TogetherAppRoutes } from './routes/app.routes';
import { TogetherMainContentComponent } from './together.main.content';
import { TogetherDIPComponent } from './components/dip.component';
import { TogetherAuctionDIPApplicantDetailComponent } from './components/dip.applicant.component';
import { TogetherAuctionDIPLoanDetailComponent } from './components/dip.loan_details.component';
import { TogetherAuctionDIPStageSelectComponent } from './components/dip.stage_select.component';
import { TogetherAuctionDIPApplicantDetailsComponent }
  from './components/dip.applicant_details.component';
import { TogetherAuctionDIPIncomeDetailsComponent }
  from './components/dip.income_details.component';
import { TogetherAuctionDIPIncomeComponent } from './components/dip.income.component';
import { TogetherAuctionDIPPropertyDetailsComponent }
  from './components/dip.property_details.component';
import { TogetherAuctionDIPOutcomeDetailsComponent }
  from './components/dip.outcome_details.component';
import { TogetherAuctionDIPLoginRecapComponent } from './components/dip.login_recap.component';
import { TogetherAuctionDIPInfoComponent } from './components/dip.dip_info.component';
import { TogetherAuctionDIPEligibilityComponent } from './components/dip.eligibility.component';
import { TogetherAuctionDIPSolicitorsComponent }
  from './components/dip.solicitors_details.component';
import { TogetherAuctionDIPApplyComponent } from './components/dip.apply.component';
import { TogetherAuctionDIPTooltipComponent } from './components/dip.tooltip.component';
import { TogetherAuctionDIPLoadingComponent } from './components/dip.loading.component';
import { TogetherAuctionDIPAdditionalDetailsComponent }
  from './components/dip.additional_details.component';
import { TogetherAuctionDIPAdditionalDetailsSecurityComponent }
  from './components/dip.additional_details.security.component';
import { TogetherAuctionDIPApplicantCompanyComponent }
  from './components/dip.applicant.company.component';
import { TogetherAuctionDIPApplicantAddressComponent }
  from './components/dip.applicant.address.component';
import { AddressComponent } from './components/address.component';
import { AddressLookupComponent } from './components/address.lookup.component';
import { AddressEditorComponent } from './components/address.editor.component';
import { AddressDisplayComponent } from './components/address.display.component';
import { ApplicantTitleComponent } from './components/dip.applicant-title.component';
import { TogetherAuctionDIPApplicantMovedInComponent }
  from './components/dip.applicant.moved-in-address.component.component';
import { TogetherAuctionDIPOutcomeComponent } from './components/dip.outcome.component';
import { TogetherAuctionDIPLoginComponent } from './components/dip.login.component';
import { TogetherAuctionDIPLoginEditComponent } from './components/dip.login.edit.component';
import { TogetherAuctionDIPFatalErrorComponent }
  from './components/dip.fatalerror.component'; // For our favourite service going down <3
import { ProgressBarComponent } from './components/progress-bar.component';
import { PageHeaderComponent } from './components/page-header.component';
import { ValidateFieldsComponent } from './components/validate-fields.component';
import { TogetherAuctionDIPJWTRedirectorComponent }
  from './components/dip.jwt-redirector.component';
import { IncomeTypeComponent } from './components/income-type.component';
import { SelfEmploymentTypeComponent } from './components/self-employment-type.component';
import { DevHeaderComponent } from './components/dev-header.component';
import { RecapApplicantComponent } from './components/recap-applicant.component';
import { RecapComponent } from './components/recap.component';
import { RecapApplicantDetailsComponent } from './components/recap-applicant-details.component';
import { RecapLoanDetailsComponent } from './components/recap-loan-details.component';
import { RecapPropertyDetailsComponent } from './components/recap-property-details.component';
import { ReferredCaseHandlerComponent } from './components/referred-case-handler.component';
import { DipOverviewComponent } from './components/dip-overview.component';

// Directives
import { TogetherMainContentDirective } from './together.main.content.directive';

// Guard
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';

// Shared services
import { DipStateService } from './services/dip-state-service.service';
import { EntityStateService } from './services/entity-state.service';
import { ExceptionService } from './services/exception.service';
import { RecapApplicantAddressComponent } from './components/recap-applicant-address.component';
import { DipSubmissionComponent } from './components/dip-submission.component';
import { RecapIncomeDetailsComponent } from './components/recap-income-details.component';
import { RecapIncomeApplicantComponent } from './components/recap-income-applicant.component';
import { ApplicationOverviewComponent } from './components/application-overview.component';
import { ApplicationSubmissionComponent } from './components/application-submission.component';
import { ApplicationOutcomeComponent } from './components/application-outcome.component';
import { RecapAdditionalSecurityComponent } from './components/recap-additional-security.component';
import { RecapSolicitorDetailsComponent } from './components/recap-solicitor-details.component';

// NG Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';//'@ng-bootstrap/ng-bootstrap';

@NgModule({ declarations: [
        AppComponent,
        // Components
        TogetherHeaderComponent,
        TogetherFooterComponent,
        TogetherMainComponent,
        TogetherMainContentComponent,
        TogetherAuctionDIPApplicantDetailComponent,
        TogetherAuctionDIPLoanDetailComponent,
        TogetherAuctionDIPStageSelectComponent,
        TogetherAuctionDIPApplicantDetailsComponent,
        TogetherAuctionDIPIncomeDetailsComponent,
        TogetherAuctionDIPIncomeComponent,
        TogetherAuctionDIPPropertyDetailsComponent,
        TogetherAuctionDIPOutcomeDetailsComponent,
        TogetherAuctionDIPLoginRecapComponent,
        TogetherAuctionDIPInfoComponent,
        TogetherAuctionDIPEligibilityComponent,
        TogetherAuctionDIPApplyComponent,
        TogetherAuctionDIPAdditionalDetailsComponent,
        TogetherAuctionDIPAdditionalDetailsSecurityComponent,
        TogetherAuctionDIPSolicitorsComponent,
        TogetherAuctionDIPApplicantCompanyComponent,
        TogetherAuctionDIPApplicantAddressComponent,
        TogetherAuctionDIPApplicantMovedInComponent,
        TogetherAuctionDIPOutcomeComponent,
        TogetherAuctionDIPTooltipComponent,
        TogetherAuctionDIPLoadingComponent,
        TogetherAuctionDIPLoginComponent,
        TogetherAuctionDIPLoginEditComponent,
        // Dynamically-loaded components
        TogetherDIPComponent,
        // Directives
        TogetherMainContentDirective,
        AddressComponent,
        AddressLookupComponent,
        AddressDisplayComponent,
        AddressEditorComponent,
        ApplicantTitleComponent,
        TogetherAuctionDIPJWTRedirectorComponent,
        ProgressBarComponent,
        PageHeaderComponent,
        IncomeTypeComponent,
        SelfEmploymentTypeComponent,
        ValidateFieldsComponent,
        TogetherAuctionDIPFatalErrorComponent,
        DevHeaderComponent,
        RecapApplicantComponent,
        RecapComponent,
        RecapApplicantDetailsComponent,
        RecapLoanDetailsComponent,
        RecapPropertyDetailsComponent,
        ReferredCaseHandlerComponent,
        DipOverviewComponent,
        RecapApplicantAddressComponent,
        DipSubmissionComponent,
        RecapIncomeDetailsComponent,
        RecapIncomeApplicantComponent,
        ApplicationOverviewComponent,
        ApplicationSubmissionComponent,
        ApplicationOutcomeComponent,
        RecapAdditionalSecurityComponent,
        RecapSolicitorDetailsComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RecaptchaModule,
        RouterModule,
        CommonModule,
        TogetherAppRoutes,
        FormsModule,
        ReactiveFormsModule,
        NgbModule], providers: [
        UnsavedChangesGuard,
        DipStateService,
        EntityStateService,
        ExceptionService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
